<template>
  <div class="background" ref="background">
    <div class="loader"></div>
  </div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "Loader",
  mounted() {
    Bus.$on("loadingStart", this.showLoading)
    Bus.$on("loadingEnd", this.hideLoading)
  },
  methods: {
    showLoading: function () {
      this.$refs.background.classList.add("show");
    },
    hideLoading: function () {
      this.$refs.background.classList.remove("show");
    },
  }
}
</script>

<style scoped>
.background {
  min-width: 100vw;
  min-height: 100vh;
  background: #00000069;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  display: none;
  overflow: auto;
}

.show {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  width: 64px;
  height: 64px;
  border: 8px solid;
  border-color: #3d5af1 transparent;
  border-radius: 50%;
  animation: spinning 1.2s linear infinite;
}

@keyframes spinning {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>